/* eslint-disable no-useless-escape */
const regexpPairs = [
  { pattern: /[ãàáäâÁÀÃÂ]/g, replacement: 'a' },
  { pattern: /[ẽèéëêÈÉÈÊ]/g, replacement: 'e' },
  { pattern: /[ìíïîÌÍÎ]/g, replacement: 'i' },
  { pattern: /[õòóöôÒÓÔÒ]/g, replacement: 'o' },
  { pattern: /[ùúüûÙÚÛ]/g, replacement: 'u' },
  { pattern: /[ñÑ]/g, replacement: 'n' },
  { pattern: /[çÇ]/g, replacement: 'c' },
  { pattern: /[\.·\\\/_,\:;=]/g, replacement: '' }
];
const mapChar = (letter: string) => {
  return regexpPairs.reduce(
    (acc, { pattern, replacement }) => acc.replace(pattern, replacement),
    letter
  );
};
export function slugify(input: string): string {
  return input
    .split('')
    .map(mapChar)
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-e-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-'); // Replace multiple - with single -
}
